var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules__card",class:[_vm.getColor, _vm.getShape, _vm.setLayoutColor]},[_c('div',{staticClass:"rules__card_text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }